<template>
  <Breadcrumbs
      title="Invoice Payments"
      :breadcrumbs="[
      { label: 'Sales', path: '' },
      { label: 'Invoices', path: '/invoice' },
      { label: 'Invoice Payments', path: '/invoice-payment' },
    ]"
  />
  <div class="container-fluid">
    <div class="row project-cards">
      <invoicePaymentList/>
    </div>
  </div>
</template>

<script>
import invoicePaymentList from "@/pages/invoice/invoicePayments/invoicePaymentsList.vue";
export default {
  name: 'invoicePayment',
  components: {
    invoicePaymentList,
  },
}
</script>
